import { FC } from 'react';
import { Box, Svg, SvgBubble, Tooltip } from '@hopskipdrive/react-components';
import { ButtonLink } from '@rideiq/shared/components';
import { isToday, parse } from 'date-fns';

interface IPauseRider {
  slug: string;
  state: 'active' | 'deactivated' | 'paused';
  pausedAt?: Nullable<string>;
  pauseDisabled: boolean;
  pauseDisabledReason: string;
}

const PauseRider: FC<IPauseRider> = ({ slug, state, pausedAt, pauseDisabled, pauseDisabledReason }) => {
  const pauseDay = pausedAt ? parse(pausedAt, 'M/d/yyyy', new Date()) : null;
  const canPauseToday = pauseDay ? isToday(pauseDay) : true;
  const showPausedbutton = state === 'active' && canPauseToday;

  return (
    <Box display="flex" alignItems="center" gap={2}>
      {showPausedbutton && (
        <ButtonLink
          variant="contained"
          color="primary"
          size="large"
          to={`/riders/${slug}/pause_rider`}
          disabled={pauseDisabled}
        >
          Pause Rider
        </ButtonLink>
      )}
      {pauseDisabled && pauseDisabledReason && (
        <Tooltip title={pauseDisabledReason} style={{ background: 'white' }}>
          <SvgBubble data-testid="pause-disabled-bubble">
            <Svg icon="question" />
          </SvgBubble>
        </Tooltip>
      )}
    </Box>
  );
};

export { PausedLabel } from './PausedLabel';
export { ProfilePauseInfo } from './ProfilePausedInfo';
export default PauseRider;
